import { createFeatureSelector } from '@ngrx/store';
import { ReducersType } from './reducers';
import { ReducerState } from '@app/shared/models';
import { CONTENT_FEATURE_KEY } from './keys';

const selectState = createFeatureSelector<ReducerState<ReducersType>>(CONTENT_FEATURE_KEY);

export { selectState };
